import { render, staticRenderFns } from "./CostsCenters.vue?vue&type=template&id=9fc3cef6&"
import script from "./CostsCenters.vue?vue&type=script&lang=js&"
export * from "./CostsCenters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports